import React from 'react';
import PropTypes from 'prop-types';

const CustomErrorMessage = ({children}) => (
    <div className="cybersource-form-error">
        {children}
    </div>
);

CustomErrorMessage.propTypes = {
    children: PropTypes.node.isRequired
};

export default CustomErrorMessage;
